import { initialState } from "./state";

export const FileUpload = (state = initialState, action) => {
  switch (action.type) {
    case "SET_URL": {
      return Object.assign({}, state, {
        UploadedFileURL: action.data
      });
    }
    default:
      return state;
  }
};
